module.exports = __webpack_public_path__ + "static/universite-bordeaux-logo-6a8ec5dc9d2882adf20373cc780ac9da.jpg";